var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.isComingSoonProduct
      ? _c(
          "button",
          {
            staticClass:
              "wf-add-to-cart-button btn btn-primary mb-3 pdp-quantity-and-size text-uppercase aside-sticky-button-width",
            on: { click: _vm.redirectToRepLocator }
          },
          [
            _c("span", { staticClass: "ml-2" }, [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.$resourceString["pdp.button.contactyourrep"]) +
                  "\n    "
              )
            ])
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.selectedColor.customPdqAvailable
      ? _c(
          "div",
          { staticClass: "description d-flex align-items-center mb-3" },
          [
            _c("span", {
              staticClass: "png-icon png-icon-icons-symbols--r-txtpdq-boxed"
            }),
            _vm._v(" "),
            _c("span", { staticClass: "ml-1" }, [
              _vm._v(
                "\n      " +
                  _vm._s(
                    _vm.$resourceString[
                      "product.details.aside.bottom.pdq.available"
                    ]
                  ) +
                  "\n    "
              )
            ])
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.isRug
      ? _c(
          "div",
          {
            staticClass:
              "description text-uppercase pdp-quantity-and-size bg-white mt-2"
          },
          [
            _c(
              "div",
              {
                staticClass:
                  "rugs-select-size-block my-3 border-0 aside-sticky-button-width position-relative"
              },
              [
                _c(
                  "div",
                  { staticClass: "pdp-sample-size-options mt-3 mt-xl-0 mb-3" },
                  [
                    _c(
                      "button",
                      {
                        staticClass: "btn dropdown-toggle px-1",
                        attrs: {
                          type: "button",
                          id: "dropdownMenuButton",
                          "data-toggle": "dropdown",
                          "aria-haspopup": "true",
                          "aria-expanded": "false"
                        }
                      },
                      [
                        _c("p", { staticClass: "m-0 px-2 option-display" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.getSelectedOption) +
                              "\n          "
                          )
                        ]),
                        _vm._v(" "),
                        _c("span", {
                          staticClass:
                            "png-icon png-icon-icons-glyph--g-chevron-down"
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "dropdown-menu w-100",
                        attrs: { "aria-labelledby": "dropdownMenuButton" }
                      },
                      _vm._l(_vm.rugsSizesOptions, function(option, index) {
                        return _vm.getSelectedOption != option.label
                          ? _c(
                              "div",
                              {
                                key: option.value,
                                staticClass: "option",
                                on: {
                                  click: function($event) {
                                    return _vm.changeRugs(option.value)
                                  }
                                }
                              },
                              [
                                _vm.getSelectedOption != option.label
                                  ? _c("span", [_vm._v(_vm._s(option.label))])
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.rugsSizesOptions.length > 1 &&
                                index < _vm.rugsSizesOptions.length - 1 &&
                                _vm.getSelectedOption !== option.label
                                  ? _c("hr")
                                  : _vm._e()
                              ]
                            )
                          : _vm._e()
                      }),
                      0
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass:
                      "d-block text-uppercase border border-dark p-2 my-3 text-dark text-decoration-none",
                    attrs: { href: "/RepLocator" }
                  },
                  [
                    _vm._v(
                      _vm._s(
                        _vm.$resourceString[
                          "product.details.aside.top.pricing.info"
                        ]
                      )
                    )
                  ]
                )
              ]
            )
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    !_vm.isComingSoonProduct && !_vm.isRug
      ? _c(
          "div",
          { staticClass: "mb-4" },
          [
            _c("wf-add-to-cart-button", {
              attrs: {
                "selling-style-number": _vm.sellingStyleNumber,
                "color-number": _vm.selectedColor.colorNumber,
                "trusted-user-flag": _vm.trustedUserDetails,
                isPDP: true,
                cssClasses: "btn btn-primary add-to-cart-mobile-button"
              }
            })
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.customDescription
      ? _c("div", { staticClass: "custom-description-container mb-4" }, [
          _c("span", {
            staticClass: "custom-description",
            domProps: { innerHTML: _vm._s(_vm.customDescription) }
          })
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "d-none d-lg-block" }, [
      _c("div", [
        _vm.getVisibleThreeDButton && _vm.getEnable3DSource
          ? _c(
              "button",
              {
                staticClass:
                  "pdp-mobile-three-d-btn custom-aside-bottom-button btn btn-light mb-3 aside-sticky-button-width",
                on: {
                  click: function($event) {
                    _vm.redirectTo3DSource(
                      _vm.$helpers.getThreeDVisualizeUrl(
                        _vm.getThreeDSourceURL,
                        _vm.sellingStyleNumber,
                        _vm.selectedColor.colorNumber,
                        _vm.selectedInstallationMethod.name,
                        _vm.getUserGUID
                      )
                    )
                    _vm.$gtm.visualizeIn3dEvent()
                  }
                }
              },
              [
                _c("img", {
                  staticClass: "mr-2 three-d-icon",
                  attrs: { src: _vm.getThreeDSourceIcon, width: "26" }
                }),
                _vm._v(" "),
                _c("span", [
                  _vm._v(
                    _vm._s(_vm.$resourceString["product.details.3DVisualize"])
                  )
                ])
              ]
            )
          : _vm._e()
      ]),
      _vm._v(" "),
      _vm.chromaUrl && !_vm.isRug && !_vm.isResinous
        ? _c("div", [
            _vm.chromaUrl && !_vm.isRug
              ? _c(
                  "button",
                  {
                    staticClass:
                      "w-100 mb-3 custom-aside-bottom-button btn btn-light customize-with-chroma-button aside-sticky-button-width justify-content-between",
                    on: { click: _vm.redirectToChroma }
                  },
                  [
                    _c("span", {
                      staticClass: "png-icon png-icon-icons-chroma-color"
                    }),
                    _vm._v(" "),
                    _c("span", [
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _vm.$resourceString[
                              "product.details.aside.bottom.customize.with.chroma"
                            ]
                          ) +
                          "\n        "
                      )
                    ])
                  ]
                )
              : _vm._e()
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.isRoomvoVisualizerEnabled
        ? _c(
            "div",
            {
              staticClass: "roomvo-container",
              attrs: { "data-product-type-str": "floor" }
            },
            [
              _c(
                "a",
                {
                  staticClass:
                    "roomvo-stimr w-100 custom-aside-bottom-button btn btn-light mb-3 aside-sticky-button-width",
                  staticStyle: { visibility: "hidden", cursor: "pointer" },
                  attrs: { href: "javascript:;", "data-sku": _vm.roomvoSku }
                },
                [
                  _c("span", {
                    staticClass: "png-icon png-icon-icons-glyph--k-btn-camera"
                  }),
                  _vm._v(" "),
                  _c("span", [
                    _vm._v(
                      _vm._s(
                        _vm.$resourceString["product.details.room.view.myspace"]
                      )
                    )
                  ])
                ]
              )
            ]
          )
        : _vm._e()
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row d-lg-none" }, [
      _vm.getVisibleThreeDButton && _vm.getEnable3DSource
        ? _c("div", { staticClass: "col-6" }, [
            _c(
              "span",
              {
                staticClass:
                  "font-16 color-grey font-weight-normal text-uppercase d-block"
              },
              [
                _vm._v(
                  _vm._s(
                    _vm.$resourceString[
                      "product.Details.Label.Visualize3D.Mobile"
                    ]
                  ) + "\n      "
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass:
                  "btn btn-light mb-3 aside-sticky-button-width w-100",
                class: {
                  "custom-aside-bottom-button":
                    _vm.getVisibleThreeDButton && _vm.getEnable3DSource
                },
                attrs: {
                  disabled: !(
                    _vm.getVisibleThreeDButton && _vm.getEnable3DSource
                  )
                },
                on: {
                  click: function($event) {
                    _vm.redirectTo3DSource(
                      _vm.$helpers.getThreeDVisualizeUrl(
                        _vm.getThreeDSourceURL,
                        _vm.sellingStyleNumber,
                        _vm.selectedColor.colorNumber,
                        _vm.selectedInstallationMethod.name,
                        _vm.getUserGUID
                      )
                    )
                    _vm.$gtm.visualizeIn3dEvent()
                  }
                }
              },
              [
                _c("img", {
                  staticClass: "mr-2 three-d-icon m-auto",
                  attrs: { src: _vm.getThreeDSourceIcon, width: "25" }
                }),
                _vm._v(" "),
                _c("span", { staticClass: "d-none d-lg-block" }, [
                  _vm._v(
                    _vm._s(_vm.$resourceString["product.details.3DVisualize"])
                  )
                ])
              ]
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.isViewinmyroomEnabled
        ? _c("div", { staticClass: "col-6" }, [
            _c(
              "span",
              {
                staticClass:
                  "font-16 color-grey font-weight-normal text-uppercase d-block"
              },
              [
                _vm._v(
                  _vm._s(
                    _vm.$resourceString[
                      "product.Details.Label.VisualizeMySpace.Mobile"
                    ]
                  ) + "\n      "
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "roomvo-container",
                attrs: { "data-product-type-str": "floor" }
              },
              [
                _c(
                  "a",
                  {
                    staticClass:
                      "roomvo-stimr custom-aside-bottom-button btn btn-light mb-3 aside-sticky-button-width",
                    staticStyle: { visibility: "hidden", cursor: "pointer" },
                    attrs: { href: "javascript:;", "data-sku": _vm.roomvoSku }
                  },
                  [
                    _c("span", {
                      staticClass: "png-icon png-icon-icons-glyph--k-btn-camera"
                    }),
                    _vm._v(" "),
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          _vm.$resourceString[
                            "product.details.room.view.myspace"
                          ]
                        )
                      )
                    ])
                  ]
                )
              ]
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.chromaUrl && !_vm.isRug && !_vm.isResinous
        ? _c("div", { staticClass: "col-6" }, [
            _c(
              "span",
              {
                staticClass:
                  "font-16 color-grey font-weight-normal text-uppercase d-block"
              },
              [
                _vm._v(
                  "\n        " +
                    _vm._s(
                      _vm.$resourceString[
                        "product.details.aside.bottom.customize.with.chroma"
                      ]
                    ) +
                    "\n      "
                )
              ]
            ),
            _vm._v(" "),
            _vm.chromaUrl && !_vm.isRug && !_vm.isResinous
              ? _c(
                  "button",
                  {
                    staticClass:
                      "w-100 custom-aside-bottom-button btn btn-light customize-with-chroma-button aside-sticky-button-width justify-content-between mb-3",
                    on: { click: _vm.redirectToChroma }
                  },
                  [
                    _c("span", {
                      staticClass: "png-icon png-icon-icons-chroma-color m-auto"
                    }),
                    _vm._v(" "),
                    _c("span", { staticClass: "d-none d-lg-block" }, [
                      _vm._v(
                        "\n        " +
                          _vm._s(
                            _vm.$resourceString[
                              "product.details.aside.bottom.customize.with.chroma"
                            ]
                          ) +
                          "\n      "
                      )
                    ])
                  ]
                )
              : _vm._e()
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "col-6" }, [
        _c(
          "span",
          {
            staticClass:
              "font-16 color-grey font-weight-normal text-uppercase d-block"
          },
          [
            _vm._v(
              _vm._s(_vm.$resourceString["product.Details.DownloadHD.Button"]) +
                "\n      "
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass:
              "btn btn-white border-accent-gray-alt download-images-label bg-transparent w-100",
            attrs: { for: "download-images-select" },
            on: {
              click: function($event) {
                return _vm.downloadButton()
              }
            }
          },
          [
            _c("span", {
              staticClass:
                "png-icon png-icon-icons-glyph--k-btn-download m-auto"
            })
          ]
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }